import Rellax from "rellax";
if (jQuery(".rellax")[0]) {
  var rellax = new Rellax(".rellax", { center: true });
}
if (jQuery(".rellax-top")[0]) {
  var rellax = new Rellax(".rellax-top");
}
